import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getActivityLog } from '../../Actions/actions';
import ActivityLogView from './view/activityLogView';


class ActivityLog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userid: localStorage.getItem('userId'),
      getActivityLogData: [],
    };
  }

  componentWillMount() {
    const data = {
      pageNumber: 0,
      pageSize: 5,
      searchKeyword: '',
      userId: this.state.userid,
    };
    this.props.getActivityLog(data);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state !== nextState || this.props !== nextProps) {
      return true;
    }
    return false;
  }

  componentWillReceiveProps(nextProps) {
    const activityRecord = nextProps.data.getActivityLogApi;

    this.setState({
      getActivityLogData: activityRecord,
    });
  }


  render() {
    const { getActivityLogData } = this.state;

    return (
      <div className="container">
        <div className="main-content bg-grey">
          <ActivityLogView
            getActivityLogData={getActivityLogData}
          />

        </div>
      </div>
    );
  }
}

ActivityLog.contextTypes = {
  router: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({ data: state.data });

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getActivityLog }, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ActivityLog));
